import { render } from "./LuggageModifyPopUp.vue?vue&type=template&id=3467ae98&scoped=true"
import script from "./LuggageModifyPopUp.vue?vue&type=script&lang=js"
export * from "./LuggageModifyPopUp.vue?vue&type=script&lang=js"

import "./LuggageModifyPopUp.vue?vue&type=style&index=0&id=3467ae98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3467ae98"]])

export default __exports__